import { CheckCircle, AlertCircle, FileText, DollarSign } from 'lucide-react';
import StatCard from '../common/StatCard';
import { summaryStats } from '../../data/mockData';

const StatsGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard
        title="Coverage Rate"
        value={`${summaryStats.coverageRate}%`}
        subtitle="All payments evaluated"
        icon={CheckCircle}
        color="green"
        trend="Up from 5% sampling"
      />
      <StatCard
        title="Pending Review"
        value={summaryStats.pendingReview.toLocaleString()}
        subtitle={`${summaryStats.highPriority} high priority`}
        icon={AlertCircle}
        color="amber"
      />
      <StatCard
        title="Reviewed Today"
        value={summaryStats.reviewedToday}
        subtitle="By your team"
        icon={FileText}
        color="blue"
      />
      <StatCard
        title="Savings Identified"
        value={`$${(summaryStats.savingsIdentified / 1000).toFixed(0)}K`}
        subtitle="This month"
        icon={DollarSign}
        color="green"
        trend="+12% vs last month"
      />
    </div>
  );
};

export default StatsGrid;
